// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowSuggestion-cls1__ae3f8106e68266a4a91e{/*!*/}.BulkFollowSuggestion-cls2___544010c6dcc48ddf370{margin:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowSuggestion-cls1__ae3f8106e68266a4a91e",
	"cls2": "BulkFollowSuggestion-cls2___544010c6dcc48ddf370 BulkFollowSuggestion-cls1__ae3f8106e68266a4a91e"
};
export default ___CSS_LOADER_EXPORT___;
